/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { SVGIcons } from "cms/icons/svg-icons";

const WebpageCardIcon = (props) => {
    
    const {
        webpage,
        // style,
        // options,
        // onClickHandler
    } = props;
    const { t } = useTranslation();
    const { nav_title } = webpage || {};

    return (
        <Fragment>
            <div className='webpage-select-card'>
                <div className='webpage-display-icon'>
                    <SVGIcons.common.Page />
                </div>
                <div className='webpage-display-container'>
                    <span>{t("commons.webpage")}</span>
                    <div className='webpage-display-heading'>{nav_title}</div>
                </div>
            </div>
        </Fragment>
    );
};

export default WebpageCardIcon;
